import styled from 'styled-components';

export const ActionMenuItem = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${({ theme }) => theme.spacing(8)} ${({ theme }) => theme.spacing(10)};
  color: ${({ theme }) => theme.colours.charcoalDust};
  cursor: pointer;
  font-family: 'Open Sans';
  font-size: ${({ theme }) => theme.pxToRem(14)};
  text-align: left;
  white-space: normal;
  overflow-wrap: break-word;
  min-height: ${({ theme }) => theme.pxToRem(35)};
  line-height: 1.5;
  border-radius: ${({ theme }) => theme.pxToRem(6)};
  transition: background-color 0.2s ease-in-out;

  svg {
    flex-shrink: 0;
    margin-left: ${({ theme }) => theme.spacing(5)};
    margin-right: ${({ theme }) => theme.spacing(7)};
  }

  & + & {
    border-top: 1px solid ${({ theme }) => theme.colours.whiteSolid};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colours.whiteSolid};
  }
`;

export const ActionMenuContainer = styled.div`
  overflow: visible;
  min-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;
